"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var ArrowIcon_1 = require("../../../ArrowIcon");
var InputBox_1 = require("../../helpers/InputBox");
var InputControl_1 = require("../../helpers/InputControl");
var Icon_1 = require("../../../Icon");
var helpers_1 = require("../helpers");
var helpers_2 = require("../../../helpers");
var icons_1 = require("../../../icons");
var common_1 = require("../../../common");
var StyledInputBox = styled_components_1.default(InputBox_1.InputBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    min-width: ", ";\n"], ["\n    min-width: ", ";\n"])), helpers_1.MIN_WIDTH_COMBOBOX);
function createSearchableControl(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.formatText, formatText = _c === void 0 ? function (_a) {
        var text = _a.text;
        return text;
    } : _c, controlRef = _b.controlRef;
    return function searchableControlRenderer(_a) {
        var className = _a.className, actions = _a.actions, control = _a.control, error = _a.error, placeholder = _a.placeholder, searchTerm = _a.searchTerm, disabled = _a.disabled, size = _a.size, active = _a.active, opened = _a.opened, focused = _a.focused, text = _a.text, testId = _a.testId, onSearchTermChange = _a.onSearchTermChange, onClear = _a.onClear, option = _a.option, value = _a.value, _b = _a.hasEnterKeyStopPropagation, hasEnterKeyStopPropagation = _b === void 0 ? true : _b, style = _a.style, rest = __rest(_a, ["className", "actions", "control", "error", "placeholder", "searchTerm", "disabled", "size", "active", "opened", "focused", "text", "testId", "onSearchTermChange", "onClear", "option", "value", "hasEnterKeyStopPropagation", "style"]);
        var _c = react_1.useState(false), inputFocused = _c[0], setInputFocused = _c[1];
        var hasClear = (!!text || searchTerm !== null) && inputFocused && opened;
        var rootRef = react_1.useRef(null);
        var inputControlRef = controlRef || rootRef;
        react_1.useEffect(function () {
            if (!opened) {
                setInputFocused(false);
            }
        }, [opened]);
        return (react_1.default.createElement(StyledInputBox, __assign({}, rest, { "data-selector-id": testId, className: className, hasError: error, isDisabled: disabled, tabIndex: -1, size: size, rows: 1, actions: [
                hasClear && {
                    icon: react_1.default.createElement(Icon_1.Icon, { src: react_1.default.createElement(icons_1.ClearIcon, { error: error, disabled: disabled }) }),
                    onClick: onClear
                },
                {
                    icon: react_1.default.createElement(ArrowIcon_1.ArrowIcon, { direction: common_1.ARROW_DIRECTION.down }),
                    active: opened,
                    onClick: function () {
                        opened ? actions.close() : actions.open();
                    }
                }
            ], isActive: opened || active, isFocused: focused, onBlur: control.onBlur, onFocus: control.onFocus, onClick: control.onClick, onMouseDown: control.onMouseDown, onMouseUp: control.onMouseUp, onMouseEnter: control.onMouseEnter, onMouseLeave: control.onMouseLeave, onKeyDown: control.onKeyDown, onKeyUp: control.onKeyUp, onKeyPress: control.onKeyPress, ref: control.ref, style: control.style }),
            react_1.default.createElement(InputControl_1.InputControl, { disabled: disabled, tabIndex: 0, ref: inputControlRef, placeholder: placeholder, value: searchTerm !== null ? searchTerm : formatText({ text: text, value: value, option: option }), hasEnterKeyStopPropagation: hasEnterKeyStopPropagation, onBlur: function (e) {
                    var _a;
                    e.stopPropagation();
                    (_a = control.onBlur) === null || _a === void 0 ? void 0 : _a.call(control);
                }, onFocus: function (e) {
                    var _a, _b;
                    (_a = inputControlRef.current) === null || _a === void 0 ? void 0 : _a.select();
                    e.stopPropagation();
                    (_b = control.onFocus) === null || _b === void 0 ? void 0 : _b.call(control);
                    setInputFocused(true);
                }, onChange: function (e) {
                    onSearchTermChange(e.target.value);
                }, onKeyDown: function (e) {
                    if (e.keyCode !== helpers_2.KeyCode.Enter) {
                        e.stopPropagation();
                    }
                    if (e.which === helpers_2.KeyCode.Tab) {
                        setInputFocused(false);
                    }
                }, maxLength: 1024 })));
    };
}
exports.createSearchableControl = createSearchableControl;
var templateObject_1;
//# sourceMappingURL=searchableControlRenderer.js.map